/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import {
  Grid,
  TextField,
  Button,
  MenuItem,
  Typography,
  Paper,
  Box,
  InputLabel,
  Select,
  FormControl,
  Card,
  Avatar,
  IconButton,
  FormHelperText,
  CircularProgress,
  Tooltip,
  Snackbar,
  Alert,
  Chip,
  Popper,
  ClickAwayListener,
  Autocomplete,
} from "@mui/material";
import {
  FirstPage,
  ChevronLeft,
  ChevronRight,
  LastPage,
  Edit,
  Clear,
  Event,
} from "@mui/icons-material";
import { MaterialReactTable } from "material-react-table";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import { useQuery } from "@tanstack/react-query";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import handleExport from "utils/exportData";
import { IconTableExport } from "@tabler/icons-react";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { convertUtcToIST } from "utils/ISTConvert";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import MDBox from "components/MDBox";
import MDAutocomplete from "components/MDAutocomplete";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDTextField from "components/MDTextField";
import LeaveActionDialog from "../leave_management/LeaveActionDialog";
import { Visibility } from "@mui/icons-material";
import AttendanceDialog from "./attendanceDialog";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { addDays, format } from "date-fns";
import { enUS } from "date-fns/locale";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const AttendanceList = () => {
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [columnFilters, setColumnFilters] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [filters, setFilters] = useState({
    user_name: "",
    district_name: "",
    // leave_type: "",
    start_date: null,
    end_date: null,
    // reason: "",
    status: "",
    date_range: null,
  });
  const genders = ["Male", "Female", "Other"];
  const leaveOptions = [
    { title: "On Duty", value: "On Duty" },
    { title: "Sick Leave", value: "Sick Leave" },
    { title: "Casual Leave", value: "Casual Leave" },
    // { title: "Paid Leave", value: "Paid Leave" },
  ];
  const statusOptions = [
    { title: "Approved", value: "Approved" },
    { title: "Pending", value: "Pending" },
    { title: "Declined", value: "Declined" },
  ];
  const attendanceOptions = [
    { title: "Present", value: "Present" },
    { title: "Present (On Duty)", value: "Present (On Duty)" },
    { title: "Leave", value: "Leave" },
    { title: "Absent", value: "Absent" },
    { title: "Holiday Attendance", value: "Holiday Attendance" },
  ];
  const dateOptions = [
    { title: "Current Month", value: "this_month" },
    { title: "Previous Month", value: "previous_month" },
    { title: "Last 3 Months", value: "last_3_months" },
    { title: "Last 6 Months", value: "last_6_months" },
    { title: "This Year", value: "this_year" },
    { title: "Previous Year", value: "previous_year" },
  ];
  const [sorting, setSorting] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [exportData, setExportData] = useState([]);
  const [message, setMessage] = useState({
    status: "",
    title: "",
    msg: "",
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [showCurrentMonthNote, setShowCurrentMonthNote] = useState(true);
  const [selectedDateRange, setSelectedDateRange] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const navigate = useNavigate();

  const fetchUsers = async (
    pageIndex = 0,
    pageSize = 10,
    filterValues = filters,
    sortValues = sorting,
    columnFilters = []
  ) => {
    setLoading(true);
    try {
      const today = dayjs();
      const firstDayOfMonth = today.startOf("month").format("DD-MM-YYYY");
      const currentDate = today.format("DD-MM-YYYY");
      const startDate = filterValues.start_date
        ? dayjs(filterValues.start_date, "DD-MM-YYYY").format("DD-MM-YYYY")
        : firstDayOfMonth;

      const endDate = filterValues.end_date
        ? dayjs(filterValues.end_date, "DD-MM-YYYY").format("DD-MM-YYYY")
        : currentDate;
      const queryParams = new URLSearchParams({
        page: pageIndex + 1,
        limit: pageSize,
        columnFilters: JSON.stringify(columnFilters),
        user_name: filterValues.user_name,
        district_name: filterValues.district_name,
        // leave_type: filterValues.leave_type,
        start_date: startDate,
        end_date: endDate,
        // reason: filterValues.reason,
        status: filterValues.status,
      });

      // Append sorting info
      if (sortValues.length > 0) {
        const sortField = sortValues[0].id;
        const sortOrder = sortValues[0].desc ? "desc" : "asc";
        queryParams.append("sortField", sortField);
        queryParams.append("sortOrder", sortOrder);
      }

      const authResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/me`,
        {},
        { withCredentials: true }
      );

      const { role_id, user_id } = authResponse.data;
      setUserRole(role_id);

      // Add them to query params
      queryParams.append("role_id", role_id);
      queryParams.append("user_id", user_id);

      const route = role_id === 3 ? "/attendance/role3" : "/attendance/general";

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}${route}?${queryParams.toString()}`,
        {
          withCredentials: true,
        }
      );

      if (res.data.status === 200) {
        const enrichedData = res.data.data.map((user) => ({
          ...user,
          start_date: res.data.start_date,
          end_date: res.data.end_date,
        }));
        setData(enrichedData);
        setRowCount(res.data.total ?? 0);
        setExportData(enrichedData);
      }
    } catch (err) {
      console.error("Error fetching users:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers(pagination.pageIndex, pagination.pageSize, filters, sorting, columnFilters);
  }, [pagination, sorting, columnFilters]);

  const handleFirstPage = () => {
    if (pagination.page > 0) fetchUsers(0);
  };

  const handlePrevPage = () => {
    if (pagination.page > 0) fetchUsers(pagination.page - 1);
  };

  const handleNextPage = () => {
    if (pagination.page < pagination.totalPages - 1) fetchUsers(pagination.page + 1);
  };

  const handleLastPage = () => {
    if (pagination.page < pagination.totalPages - 1) fetchUsers(pagination.totalPages - 1);
  };

  const fetchDistrict = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/districts/all`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data.data;
  };

  const {
    data: districtData,
    error: districtError,
    isLoading: districtIsLoading,
  } = useQuery({
    queryKey: ["fetchDistrict"],
    queryFn: fetchDistrict,
    retry: false,
  });

  const fetchStatus = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/status/all`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data.data;
  };

  const {
    data: fetchedStatus,
    error: statusError,
    isLoading: statusIsLoading,
  } = useQuery({
    queryKey: ["fetchStatus"],
    queryFn: fetchStatus,
    retry: false,
  });

  const statusData =
    fetchedStatus?.map((status) => ({
      title: status.name,
      value: status.status_id,
    })) || [];

  const fetchAllUsers = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/user/all?page=1&limit=10000`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data.data;
  };

  const {
    data: usersData,
    error: usersError,
    isLoading: usersIsLoading,
  } = useQuery({
    queryKey: ["fetchAllUsers"],
    queryFn: fetchAllUsers,
    retry: false,
  });

  const allUsersData = useMemo(() => {
    if (!usersData) return [];
    const uniqueNames = [...new Set(usersData.map((user) => user.user_name).filter(Boolean))];
    return uniqueNames.map((name) => ({
      label: name,
      value: name,
    }));
  }, [usersData]);

  const districtOptions =
    districtData?.map((district) => ({
      label: district.title,
      value: district.value,
    })) || [];

  const columns = useMemo(() => {
    // For role_id === 3 → Normal view
    if (userRole === 3) {
      return [
        {
          accessorKey: "attendance_date",
          header: "Date",
          size: 150,
          Filter: ({ column }) => {
            const [open, setOpen] = useState(false);
            return (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={open}
                  onOpen={() => setOpen(true)}
                  onClose={() => setOpen(false)}
                  format="DD-MM-YYYY"
                  value={
                    column.getFilterValue() ? dayjs(column.getFilterValue(), "DD-MM-YYYY") : null
                  }
                  onChange={(newValue) => {
                    column.setFilterValue(newValue ? newValue.format("DD-MM-YYYY") : undefined);
                  }}
                  slotProps={{
                    textField: {
                      onClick: () => setOpen(true),
                      placeholder: "Filter Date",
                      variant: "standard",
                      fullWidth: true,
                      InputProps: {
                        endAdornment: (
                          <React.Fragment>
                            {column.getFilterValue() && (
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  column.setFilterValue(undefined);
                                }}
                                size="small"
                              >
                                <Clear fontSize="small" />
                              </IconButton>
                            )}
                            <IconButton size="small" onClick={() => setOpen(true)}>
                              <Event fontSize="small" />
                            </IconButton>
                          </React.Fragment>
                        ),
                      },
                    },
                    actionBar: {
                      actions: ["cancel", "accept"],
                    },
                  }}
                />
              </LocalizationProvider>
            );
          },
          Cell: ({ row }) => convertUtcToIST(row?.original?.attendance_date) ?? "-",
        },
        {
          accessorKey: "status",
          header: "Attendance Status",
          Filter: ({ column }) => {
            return (
              <Autocomplete
                options={attendanceOptions}
                getOptionLabel={(option) => option.title || ""}
                value={
                  attendanceOptions.find((option) => option.value === column.getFilterValue()) ||
                  null
                }
                onChange={(event, newValue) => {
                  column.setFilterValue(newValue ? newValue.value : undefined);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Filter Status"
                    variant="standard"
                    sx={{
                      "& .MuiInputBase-input": { fontSize: "12px" },
                    }}
                  />
                )}
              />
            );
          },
          Cell: ({ row }) => (
            <Chip
              sx={{
                height: "auto",
                "& .MuiChip-label": {
                  color: "white !important",
                  fontSize: "14px",
                  fontWeight: "bold",
                },
              }}
              color={
                row?.original?.status === "Present" || row?.original?.status === "Present (On Duty)"
                  ? "success"
                  : row?.original?.status === "Absent"
                    ? "error"
                    : row?.original?.status === "Holiday"
                      ? "info"
                      : row?.original?.status === "Holiday Attendance"
                        ? "warning"
                        : "secondary"
              }
              label={row?.original?.status}
            />
          ),
        },
        {
          accessorKey: "leave_type",
          header: "Leave Type",
          Filter: ({ column }) => {
            return (
              <Autocomplete
                options={leaveOptions}
                getOptionLabel={(option) => option.title || ""}
                value={
                  leaveOptions.find((option) => option.value === column.getFilterValue()) || null
                }
                onChange={(event, newValue) => {
                  column.setFilterValue(newValue ? newValue.value : undefined);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Filter Type"
                    variant="standard"
                    sx={{
                      "& .MuiInputBase-input": { fontSize: "12px" },
                    }}
                  />
                )}
              />
            );
          },
          Cell: ({ row }) => (row.original.leave_type === "On Duty" ? "-" : row.original.leave_type) || "-",
        },
        {
          accessorKey: "is_additional_holiday",
          header: "Holiday Attendance",
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => {
            const isAdd = row.original.is_additional_holiday;
            const isStat = row.original.status === "Holiday Attendance";
            return isAdd === 1 || isStat ? (
              <Chip
                label="Yes"
                color="info"
                sx={{
                  height: "auto",
                  "& .MuiChip-label": {
                    color: "white !important",
                    fontSize: "14px",
                    fontWeight: "bold",
                  },
                }}
              />
            ) : "-";
          },
        },
        {
          accessorKey: "logIn_time",
          header: "Check-In Time",
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => {
            const time = row.original.logIn_time;
            if (!time) return "-";
            const [hour, minute] = time.split(":");
            const h = parseInt(hour);
            const suffix = h >= 12 ? "PM" : "AM";
            const formatted = `${((h + 11) % 12) + 1}:${minute} ${suffix}`;
            return formatted;
          },
        },
        {
          accessorKey: "logOut_time",
          header: "Check-Out Time",
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => {
            const time = row.original.logOut_time;
            if (!time) return "-";
            const [hour, minute] = time.split(":");
            const h = parseInt(hour);
            const suffix = h >= 12 ? "PM" : "AM";
            const formatted = `${((h + 11) % 12) + 1}:${minute} ${suffix}`;
            return formatted;
          },
        },
        {
          accessorKey: "geotag_img",
          header: "Attendance Image",
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => {
            if (row.original.geotag_img) {
              return (
                <MDBox
                  component="img"
                  src={row.original.geotag_img}
                  alt="Attendance"
                  sx={{
                    width: "45px",
                    height: "45px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    transition: "transform 0.2s ease",
                    "&:hover": {
                      transform: "scale(2.5)",
                      zIndex: 10,
                      position: "relative",
                    },
                  }}
                  onClick={() => window.open(row.original.geotag_img, "_blank")}
                />
              );
            }

            if (row.original.documents) {
              try {
                const docs = JSON.parse(row.original.documents);
                if (Array.isArray(docs) && docs.length > 0) {
                  return (
                    <MDBox display="flex" flexDirection="column" gap={0.5}>
                      {docs.map((url, idx) => (
                        <MDTypography
                          key={idx}
                          component="a"
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{
                            color: "#1a73e8",
                            textDecoration: "underline",
                            cursor: "pointer",
                            fontSize: "12px",
                            fontWeight: "bold",
                            "&:hover": { color: "#1557b0" },
                          }}
                        >
                          📄 Doc {idx + 1}
                        </MDTypography>
                      ))}
                    </MDBox>
                  );
                }
              } catch (e) {
                // ignore
              }
            }

            return "-";
          },
        },
      ];
    }

    // For role_id !== 3 → Grouped summary view
    return [
      {
        accessorKey: "user_name",
        header: "Name",
        filterVariant: "autocomplete",
        filterSelectOptions: allUsersData,
        Cell: ({ row }) => row.original.user_name ?? "-",
        enableColumnFilters: true,
      },
      {
        accessorKey: "district_name",
        header: "District",
        // eslint-disable-next-line react/prop-types
        enableColumnFilter: true,
        // eslint-disable-next-line react/prop-types
        Filter: ({ column }) => {
          return (
            <Autocomplete
              options={districtOptions}
              value={
                // eslint-disable-next-line react/prop-types
                districtOptions.find((option) => option.label === column.getFilterValue()) || null
              }
              onChange={(event, newValue) => {
                // eslint-disable-next-line react/prop-types
                column.setFilterValue(newValue ? newValue.label : undefined);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Filter by District"
                  variant="standard"
                  sx={{
                    "& .MuiInputBase-root": {
                      color: "#fff",
                      fontSize: "12px", // Match header font size
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#e0e0e0",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#fff",
                      transform: "scaleX(1)",
                    },
                    "& .MuiSvgIcon-root": {
                      // Dropdown arrow
                      color: "#fff",
                    },
                  }}
                />
              )}
              sx={{ minWidth: "120px" }}
            />
          );
        },
      },
      {
        accessorKey: "total_days",
        header: "Total Days",
        enableColumnFilter: false,
        enableSorting: false,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },
      {
        accessorKey: "holidays",
        header: "Holidays",
        enableColumnFilter: false,
        enableSorting: false,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },
      {
        accessorKey: "additional_holidays",
        header: "Holiday Attendance",
        enableColumnFilter: false,
        enableSorting: false,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },
      // {
      //   accessorKey: "working_days",
      //   header: "Working Days",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      // },
      {
        accessorKey: "present_count",
        header: "Present",
        enableColumnFilter: false,
        enableSorting: false,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },
      {
        accessorKey: "leave_count",
        header: "Leave",
        enableColumnFilter: false,
        enableSorting: false,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },
      {
        accessorKey: "absent_count",
        header: "Absent",
        enableColumnFilter: false,
        enableSorting: false,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },
      {
        accessorKey: "view",
        header: "Action",
        enableColumnFilter: false,
        enableSorting: false,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        Cell: ({ row }) => (
          <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
            <Tooltip title="Click to View">
              <span>
                <IconButton
                  key={row.id}
                  // onClick={() => {
                  //   const fullRow = row.original;
                  //   console.log("row.original", row.original);

                  //   // Parse the attendance_data if it's a JSON string
                  //   const parsedAttendanceData =
                  //     typeof fullRow.attendance_data === "string"
                  //       ? JSON.parse(fullRow.attendance_data)
                  //       : fullRow.attendance_data;
                  //   setSelectedId({
                  //     ...fullRow,
                  //     user_id: fullRow.user_id,
                  //     start_date: fullRow.start_date || "",
                  //     end_date: fullRow.end_date || "",
                  //   });
                  //   setDialogOpen(true);
                  // }}
                  onClick={() => {
                    navigate("/attendance-details", {
                      state: {
                        user_id: row.original.user_id,
                        start_date: row.original.start_date || "",
                        end_date: row.original.end_date || "",
                      },
                    });
                  }}
                  disabled={loading}
                  sx={{
                    color: "#1976d2",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                    transition: "background-color 0.3s, transform 0.3s",
                    "&:hover": {
                      backgroundColor: "#1976d2",
                      color: "#fff",
                      transform: "scale(1.05)",
                    },
                    "&:active": {
                      transform: "scale(0.95)",
                    },
                  }}
                >
                  {loading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <Visibility sx={{ width: 20, height: 20 }} />
                  )}
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        ),
      },
    ];
  }, [userRole, loading]);

  const handleExportData = async () => {
    try {
      let formattedData = [];
      let role_id, user_id;

      if (rowSelection && Object.keys(rowSelection).length > 0) {
        formattedData = exportData.filter((item) => rowSelection[item.id]);
      } else {
        const queryParams = new URLSearchParams({
          user_name: filters.user_name,
          district_name: filters.district_name,
          start_date: filters.start_date ? dayjs(filters.start_date).format("DD-MM-YYYY") : "",
          end_date: filters.end_date ? dayjs(filters.end_date).format("DD-MM-YYYY") : "",
          status: filters.status,
          page: 1,
          limit: 10000,
        });

        if (sorting.length > 0) {
          const sortField = sorting[0].id;
          const sortOrder = sorting[0].desc ? "desc" : "asc";
          queryParams.append("sortField", sortField);
          queryParams.append("sortOrder", sortOrder);
        }

        const authResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}/auth/me`,
          {},
          { withCredentials: true }
        );

        ({ role_id, user_id } = authResponse.data); // ✅ assign to outer variables
        setUserRole(role_id);

        queryParams.append("role_id", role_id);
        queryParams.append("user_id", user_id);

        const route = role_id === 3 ? "/attendance/role3" : "/attendance/general";

        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}${route}?${queryParams.toString()}`,
          { withCredentials: true }
        );

        if (res.data.status === 200) {
          formattedData = res.data.data;
        }
      }

      if (formattedData.length === 0) {
        console.log("No data found to export");
        setMessage({
          status: "error",
          title: "Error",
          msg: "No data found to export.",
        });
        return;
      }

      const fileName = role_id === 3 ? "Attendance_List_Data" : "Attendance_List_Count_Data"; // ✅ role_id now defined

      await handleExport(formattedData, fileName, districtData, statusData);

      setMessage({
        status: "success",
        title: "Success",
        msg: "Excel downloaded successfully!",
      });
    } catch (error) {
      console.error(" Export error:", error);
      setMessage({
        status: "error",
        title: "Error",
        msg: "Something went wrong during export.",
      });
    }
  };

  const handleActionSuccess = () => {
    fetchUsers(); // refetch the list manually
  };

  const handleDateRangeChange = (newValue) => {
    const today = dayjs();
    let start = null;
    let end = null;

    if (!newValue || typeof newValue !== "string") {
      console.warn("Invalid date range selection:", newValue);
      return;
    }

    switch (newValue) {
      case "this_month":
        start = today.startOf("month");
        end = today.endOf("month");
        break;
      case "previous_month":
        start = today.subtract(1, "month").startOf("month");
        end = today.subtract(1, "month").endOf("month");
        break;
      case "last_3_months":
        start = today.subtract(3, "month").startOf("month");
        end = today.endOf("month");
        break;
      case "last_6_months":
        start = today.subtract(6, "month").startOf("month");
        end = today.endOf("month");
        break;
      case "this_year":
        start = today.startOf("year");
        end = today.endOf("year");
        break;
      case "previous_year":
        start = today.subtract(1, "year").startOf("year");
        end = today.subtract(1, "year").endOf("year");
        break;
      default:
        break;
    }

    // console.log("Today is:", today.format("DD-MM-YYYY"));
    // console.log("start:", start?.format?.("DD-MM-YYYY"));
    // console.log("end:", end?.format?.("DD-MM-YYYY"));

    const updatedFilters = {
      ...filters,
      start_date: start.format("DD-MM-YYYY"),
      end_date: end.format("DD-MM-YYYY"),
    };

    // console.log("✅ handleDateRangeChange sets filters:", updatedFilters);
    setFilters(updatedFilters);
  };

  return (
    <DashboardLayout>
      {/* <Card id="delete-account">
     
      </Card> */}
      <MDBox mt={3} />
      <Card id="delete-account" sx={{ mb: 4 }}>
        <MDBox pt={2} px={2}>
          {/* <MDBox mt={5} mb={3}> */}
          <Grid container spacing={1} display={"flex"} alignItems={"center"}>
            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
              <MDTypography variant="h5" fontWeight="medium">
                Attendance
              </MDTypography>
            </Grid>
            {/* Hiding redundant button as requested */}
          </Grid>
          {/* </MDBox> */}
        </MDBox>
        <MDBox mb={2} />
        <MDBox p={2}>
          <Grid container spacing={3}>
            {userRole !== 3 && (
              <>
                <Grid item size={{ xs: 12, md: 4 }}>
                  <MDAutocomplete
                    label="User Name"
                    name="user_name"
                    value={filters.user_name}
                    options={allUsersData}
                    onChange={(newValue) => {
                      setFilters({ ...filters, user_name: newValue });
                    }}
                    isFilter={true}
                    getOptionLabel={(option) => option.label}
                  />
                </Grid>
                <Grid item size={{ xs: 12, md: 4 }}>
                  <MDAutocomplete
                    label="District"
                    name="district_name"
                    value={filters.district_name}
                    options={districtOptions}
                    onChange={(newValue) => {
                      setFilters({ ...filters, district_name: newValue });
                    }}
                    isFilter={true} // optional: add a flag if you need special styling
                    getOptionLabel={(option) => option.label}
                  />
                </Grid>
                {/* <Grid item size={{ xs: 12, md: 4 }}>
                  <MDAutocomplete
                    label="Date Range"
                    name="date_range"
                    value={selectedDateRange}
                    options={dateOptions}
                    getOptionLabel={(option) => option?.title || ""}
                    onChange={(newValue) => {
                      console.log("🎯 Selected Date Range Option:", newValue);
                      setSelectedDateRange(newValue); // so it stays selected
                      handleDateRangeChange(newValue); // now it gets the correct value
                    }}
                    isFilter={true}
                  />
                </Grid> */}
                <Grid item size={{ xs: 12, md: 4 }}>
                  <Box sx={{ width: "100%", position: "relative" }}>
                    <Typography sx={{ fontSize: "0.887rem", fontWeight: 400, mb: 0.3 }}>
                      Date Range
                    </Typography>
                    <TextField
                      fullWidth
                      value={
                        filters.start_date && filters.end_date
                          ? `${filters.start_date} to ${filters.end_date}`
                          : ""
                      }
                      placeholder="Select Date Range"
                      onClick={(e) => {
                        setAnchorEl(e.currentTarget);
                        setOpenCalendar(true);
                      }}
                      InputProps={{
                        readOnly: true,
                        sx: {
                          cursor: "pointer",
                          backgroundColor: "#fff",
                          height: "51px",
                        },
                      }}
                    />
                    <Popper
                      open={openCalendar}
                      anchorEl={anchorEl}
                      placement="bottom-start"
                      style={{ zIndex: 1300 }}
                    >
                      <ClickAwayListener onClickAway={() => setOpenCalendar(false)}>
                        <Box
                          sx={{
                            mt: 1,
                            bgcolor: "white",
                            boxShadow: 3,
                            borderRadius: 2,
                            p: 2,
                            zIndex: 1301,
                          }}
                        >
                          <DateRange
                            editableDateInputs={true}
                            onChange={(item) => {
                              setSelectedDateRange([item.selection]);
                              const start = item.selection.startDate;
                              const end = item.selection.endDate;
                              setFilters({
                                ...filters,
                                start_date: start ? format(start, "dd-MM-yyyy") : "",
                                end_date: end ? format(end, "dd-MM-yyyy") : "",
                              });
                              if (start && end && start.getTime() !== end.getTime()) {
                                setOpenCalendar(false);
                              }
                            }}
                            moveRangeOnFirstSelection={false}
                            ranges={selectedDateRange}
                            rangeColors={["#1976d2"]}
                            maxDate={new Date()}
                            locale={enUS}
                          />
                        </Box>
                      </ClickAwayListener>
                    </Popper>
                  </Box>
                </Grid>
              </>
            )}
            {userRole == 3 && (
              <>
                <Grid item size={{ xs: 12, md: 4 }}>
                  <MDTypography style={{ fontSize: "16px" }} color="dark">
                    Start Date
                  </MDTypography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={filters.start_date}
                      format="DD/MM/YYYY"
                      onChange={(value) => setFilters({ ...filters, start_date: value })}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          InputProps: {
                            readOnly: true,
                            sx: {
                              fontSize: "14px",
                              height: "45px",
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item size={{ xs: 12, md: 4 }}>
                  <MDTypography style={{ fontSize: "16px" }} color="dark">
                    End Date
                  </MDTypography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={filters.end_date}
                      format="DD/MM/YYYY"
                      onChange={(value) => setFilters({ ...filters, end_date: value })}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          InputProps: {
                            readOnly: true,
                            sx: {
                              fontSize: "14px",
                              height: "45px",
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item size={{ xs: 12, md: 4 }}>
                  <MDAutocomplete
                    label="Status"
                    name="status"
                    value={filters.status}
                    options={attendanceOptions}
                    onChange={(newValue) => {
                      setFilters({ ...filters, status: newValue });
                    }}
                    isFilter={true} // optional: add a flag if you need special styling
                  />
                </Grid>
              </>
            )}
          </Grid>
        </MDBox>
        <MDBox p={2}>
          <Grid container spacing={2} justifyContent="center">
            {/* Search Button */}
            <Grid item xs={12} md={2} textAlign="center">
              <MDButton
                onClick={() => {
                  setShowCurrentMonthNote(false);
                  setTimeout(() => {
                    // console.log("✅ Using latest filters:", filters);
                    fetchUsers(0, pagination.pageSize, filters, sorting);
                  }, 0);
                }}
                sx={{
                  color: "white !important",
                  backgroundColor: "#1976d2",
                  "&:hover": {
                    backgroundColor: "#155fa0",
                  },
                  minWidth: "120px",
                }}
              >
                Search
              </MDButton>
            </Grid>

            {/* Cancel Button */}
            <Grid item xs={12} md={2} textAlign="center">
              <MDButton
                variant="outlined"
                onClick={() => {
                  const cleared = {
                    user_name: "",
                    district_name: "",
                    // leave_type: "",
                    start_date: null,
                    end_date: null,
                    // reason: "",
                    status: "",
                    date_range: null,
                  };
                  setFilters(cleared);
                  setShowCurrentMonthNote(true);
                  setSelectedDateRange([
                    {
                      startDate: new Date(),
                      endDate: new Date(),
                      key: "selection",
                    },
                  ]);
                  fetchUsers(0, pagination.pageSize, cleared);
                }}
                sx={{
                  color: "#b71c1c !important",
                  borderColor: "#b71c1c",
                  "&:hover": {
                    backgroundColor: "#fbe9e7",
                    borderColor: "#b71c1c",
                  },
                  minWidth: "120px",
                }}
              >
                Cancel
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
      <Box>
        <Grid container spacing={5}>
          <Grid size={{ xs: 12, md: 12 }} className="listTable">
            {/* <Card sx={{ padding: 3, boxShadow: 3 }}> */}
            {/* {loading ? (
              <Box display="flex" justifyContent="center" py={4}>
                <CircularProgress />
              </Box>
            ) : ( */}
            <Box sx={{ width: "100%", overflowX: "auto" }}>
              <Paper
                elevation={2}
                sx={{
                  width: "100%",
                  overflowX: "auto",
                  backgroundColor: "#fff",
                  boxShadow: "none",
                  p: 2,
                }}
              >
                {showCurrentMonthNote && (
                  <span
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginLeft: "10px",
                    }}
                  >
                    (Note: Displaying attendance data from {dayjs().startOf("month").format("MMMM DD, YYYY")} to {dayjs().format("MMMM DD, YYYY")})
                  </span>
                )}
                <MaterialReactTable
                  columns={columns}
                  data={data}
                  getRowId={(row) => row.id}
                  enableGlobalFilter={false}
                  enableFullScreenToggle={false}
                  enableColumnFilters={true}
                  enableDensityToggle={false}
                  initialState={{ showColumnFilters: false }}
                  layoutMode="grid"
                  enableRowNumbers
                  manualFiltering
                  manualPagination
                  manualSorting
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  {...(userRole === 3 && {
                    enableExpandAll: false,
                    enableExpanding: true,
                    getRowCanExpand: (row) => row.original.status === "Leave",
                    renderDetailPanel: ({ row }) => (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "16px",
                          fontSize: "14px",
                          backgroundColor: "#f3f3f3",
                          borderLeft: "4px solid #ff9800",
                          lineHeight: 1.6,
                        }}
                      >
                        <Typography>
                          <strong>Reason:</strong> {row.original.reason || "N/A"}
                        </Typography>
                      </Box>
                    ),
                    muiExpandButtonProps: ({ row }) => ({
                      sx: { marginLeft: "-10px" },
                      title: "",
                    }),
                    muiExpandAllButtonProps: {
                      sx: {
                        visibility: "hidden",
                        width: "10px",
                      },
                    },
                    displayColumnDefOptions: {
                      "mrt-row-numbers": {
                        size: 40,
                        maxSize: 40,
                        position: "left",
                        muiTableHeadCellProps: { align: "center" },
                        muiTableBodyCellProps: { align: "center" },
                      },
                      "mrt-row-expand": {
                        size: 20,
                        maxSize: 20,
                      },
                    },
                  })}
                  // onColumnFiltersChange={setColumnFilters}
                  onColumnFiltersChange={setColumnFilters}
                  // onGlobalFilterChange={setGlobalFilter}
                  // onPaginationChange={setPagination}
                  // onSortingChange={setSorting}
                  // rowCount={rowCount}
                  state={{
                    columnFilters,
                    // globalFilter,
                    // isLoading,
                    loading,
                    pagination,
                    // showAlertBanner: isError,
                    // showProgressBars: isRefetching,
                    sorting,
                  }}
                  muiTableHeadProps={{
                    sx: {
                      padding: "0px", // won't apply directly to <thead>, but useful for general structure
                      backgroundColor: "#011F3A", // background on <thead> element itself
                    },
                  }}
                  enableStickyHeader
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "70vh",
                      overflowY: "auto",
                    },
                  }}
                  enableColumnActions={false}
                  muiTableHeadCellProps={{
                    sx: {
                      backgroundColor: "#004030",
                      color: "#fff",
                      // fontSize: '16px',
                      fontWeight: "bold",
                      position: "sticky", // Make header sticky
                      top: 0, // Stick it at the top
                      zIndex: 1, // Ensure it stays
                      "& .MuiTableSortLabel-root": {
                        "& .MuiTableSortLabel-icon": {
                          color: "#fff !important",
                        },
                      },
                      "& .MuiInputBase-input": {
                        color: "#fff !important",
                        fontSize: "12px",
                        "::placeholder": {
                          color: "#e0e0e0", // Default (blurred) placeholder color
                          opacity: 1,
                        },
                      },
                      "& .MuiInputBase-root.Mui-focused .MuiInputBase-input::placeholder": {
                        color: "#ffffff", // Focused placeholder color
                      },
                      "& .MuiIconButton-root": {
                        color: "#fff",
                      },
                      "& .MuiInput-underline:before": {
                        borderBottomColor: "#e0e0e0",
                      },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: "#fff",
                      },
                      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#fff",
                      },

                      "& .MuiCheckbox-root": {
                        color: "#fff",
                      },
                    },
                  }}
                  muiTableBodyCellProps={{
                    sx: {
                      padding: "8px", // reduce from default 16px
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                  }}
                  muiTableBodyRowProps={({ row }) => ({
                    sx: {
                      backgroundColor: row.index % 2 === 0 ? "#fafafa" : "#f0f0f0", // soft alternating colors
                    },
                  })}
                  renderTopToolbarCustomActions={() => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                        marginLeft: "auto",
                      }}
                    >
                      <Tooltip title={"Export data to excel sheet"} arrow>
                        <Button
                          onClick={handleExportData}
                          sx={{
                            background:
                              "linear-gradient(90deg, rgba(2, 183, 255, 0.65) 30%,rgb(110, 199, 235) 100%)",
                            color: "#f4f4f4",
                            borderRadius: "8px",
                            padding: "10px 20px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            transition: "background 0.3s, transform 0.3s",
                            "&:hover": {
                              background:
                                "linear-gradient(90deg, rgba(55, 198, 254, 0.97) 30%,rgb(39, 169, 220) 100%))",
                              transform: "scale(1.05)",
                            },
                            "&:active": {
                              transform: "scale(0.95)",
                            },
                          }}
                          startIcon={<IconTableExport />}
                        >
                          {"Export To Excel"}
                        </Button>
                      </Tooltip>
                    </Box>
                  )}
                  displayColumnDefOptions={{
                    "mrt-row-numbers": {
                      size: 40,
                      maxSize: 40,
                      position: "left",
                      muiTableHeadCellProps: { align: "center" },
                      muiTableBodyCellProps: { align: "center" },
                    },
                  }}
                  muiTopToolbarProps={{
                    sx: {
                      backgroundColor: "#fff",
                      boxShadow: "none",
                    },
                  }}
                />
              </Paper>
            </Box>
            {/* )} */}
            {/* </Card> */}
          </Grid>
        </Grid>
      </Box>
      <Snackbar
        open={Boolean(message.status)}
        autoHideDuration={3000}
        onClose={() => setMessage({ status: "", title: "", msg: "" })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setMessage({ status: "", title: "", msg: "" })}
          severity={message.status}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message.msg}
        </Alert>
      </Snackbar>
      <Footer />
      <AttendanceDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        userData={selectedId}
        onSuccess={handleActionSuccess}
        heading={"Attendance Details"}
        headerBackgroundColors={["#7b2cbf", "#d283ff"]}
      />
    </DashboardLayout>
  );
};

export default AttendanceList;
